import { makeStyles } from '@mui/styles';
import { COLOR_GRAY_60, COLOR_PURPLE } from 'styles/variables/colors';

export const useStyles = makeStyles((theme) => ({
  codeButton: {
    lineHeight: '20px',
    color: theme.palette.common.COLOR_PURPLE_HOVER,
    fontFamily: 'Lato',
  },
  unstyledButton: {
    fontWeight: 600,
    fontSize: 16,
    textDecoration: 'underline',
  },
  headerButton: {
    fontWeight: 500,
    fontSize: 14,
    textDecoration: 'underline',
  },
  couponActivation: {
    width: 224,
    height: 42,
    borderRadius: 5,
    backgroundColor: COLOR_PURPLE,
    padding: '10px 10px',
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    '&:hover': {
      boxShadow: '0 4px 6px 0 rgba(0, 0, 0, 0.2)',

      '& a': {
        textDecoration: 'underline',
      },
    },

    '&::after': {
      position: 'absolute',
      content: '""',
      height: 16,
      width: 16,
      right: -10,
      borderRadius: 9,
      zIndex: 1,
      top: 13,
      backgroundColor: (props) => props.pseudoElementBgColor || theme.palette.common.white,
    },

    '&::before': {
      position: 'absolute',
      content: '""',
      height: 16,
      width: 16,
      left: -10,
      borderRadius: 9,
      zIndex: 1,
      top: 13,
      backgroundColor: (props) => props.pseudoElementBgColor || theme.palette.common.white,
    },

    '& a': {
      color: theme.palette.common.white,
      fontFamily: 'Lato',
      fontWeight: 700,

      '&:hover': {
        textDecoration: 'none',
      },
    },
  },
  title: {
    fontWeight: 700,
    color: COLOR_PURPLE,
    lineHeight: '40px',
    paddingBottom: theme.spacing(2),
    textAlign: 'center',
  },
  description: {
    color: COLOR_GRAY_60,
    fontWeight: 700,
    width: '100%',
    textAlign: 'center',
    paddingBottom: theme.spacing(2),

    '& a': {
      textDecoration: 'none',
    },
  },
  input: {
    paddingBottom: theme.spacing(2),

    '& input': {
      textAlign: 'center',
    },

    '&::placeholder': {
      textAlign: 'center',
    },
  },
  errorMessage: {
    color: '#ff0000',
    textAlign: 'center',
    fontSize: 12,
    paddingBottom: theme.spacing(2),
    marginTop: theme.spacing(-2),
  },
}));
